// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "assistant_conversation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { assistantConversationStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "assistant_conversation" table (1:1 with a DB row, on the wire). */
export const assistantConversationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    title: z.string().nullable(),
    activeContentItemId: z.string().nullable(),
    status: z.enum(assistantConversationStatusValues),
    escalatedAt: z.string().datetime().nullable(),
    escalationReason: z.string().nullable(),
    intercomConversationId: z.string().nullable(),
    loadedSkillIds: z.array(z.string()),
    skillRegistryVersion: z.number(),
    archivedAt: z.string().datetime().nullable(),
    channel: z.string(),
    whatsappPhoneE164: z.string().nullable(),
    pendingConfirmation: z.unknown().nullable(),
    budgetFailureCampaignIds: z.array(z.string()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=assistantConversation.js.map